import React, { forwardRef } from "react";
import { Flex, IconOnePass, Span } from "@catchoftheday/cg-components";
import { UpsellCTAWidgetPrimaryZone, UpsellCTAWidgetZone, } from "../../layouts/CTAWidgetLayout/CTAWidgetLayout";
import { UpsellSecondaryCTA, } from "../UpsellSecondaryCTA";
export const UpsellCTAWidget = forwardRef(({ isLoggedIn, isFreeTrialEligible, showSecondaryCTA, onMainCTAClick, ...secondaryCTAProps }, ref) => {
    return (<UpsellCTAWidgetZone ref={ref}>
        <UpsellCTAWidgetPrimaryZone onClick={onMainCTAClick} aria-label={isFreeTrialEligible || !isLoggedIn
            ? "Start free 30 day trial"
            : "Join OnePass today"}>
          <Flex alignItems="center" mb={2}>
            <Span fontWeight="bold" fontSize="base" whiteSpace="nowrap">
              Get free delivery with
              <IconOnePass title="OnePass" aria-label="OnePass" color="onePass.primary" width="auto" height="1em" ml={1} mb={1}/>
            </Span>
          </Flex>
          <Span fontSize="xs" fontWeight="medium">
            Join for free delivery on this item and more!{" "}
            <Span color="onePass.primary" fontWeight="bold" fontSize="inherit" textDecoration="underline" whiteSpace="nowrap">
              {isFreeTrialEligible || !isLoggedIn
            ? "Start free 30 day trial"
            : "Join OnePass today"}
            </Span>
          </Span>
        </UpsellCTAWidgetPrimaryZone>
        {showSecondaryCTA && (<UpsellSecondaryCTA tight isLoggedIn={isLoggedIn} {...secondaryCTAProps}/>)}
      </UpsellCTAWidgetZone>);
});
UpsellCTAWidget.displayName = "UpsellCTAWidget";
